import { render, staticRenderFns } from "./ChangeLog.vue?vue&type=template&id=6b027cae"
import script from "./ChangeLog.vue?vue&type=script&lang=js"
export * from "./ChangeLog.vue?vue&type=script&lang=js"
import style0 from "./ChangeLog.vue?vue&type=style&index=0&id=6b027cae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports